export const environment = {
  production: false,
  console: true,
  API_URL: 'https://apipre.apiacpos.com/2_7_0_bridge_pedrera/',
  API_URL_MS: 'https://apipre.apiacpos.com/WEBAPICoreBridge_1_0_0/',
  numSerie: 'WEBAN$A$l06$A$GULAR$A$AM3[jC)',
  chClaveEmpresa: 'PEDRERA',
  chNombreProyecto: 'VENTAONLINE',
  chEntornoConexion: 'DESARROLLO',
  chOrigenConexion: 'INTERNET',
  chPasarelaEntorno: 'DESARROLLO',
  pasarelaRedsys: 'DESARROLLO',
  pasarelaPhoneSell: 'PHONE_M_PRE',
  pasarelaEntornoPhoneSell: 'CONSULTA_PRE',
  pasarelaPaypal: 'PAYPAL_PRE',
  URL_PDF: 'http://grecpruebas.iacpos.com/grec-api/tickets/',
  URLOK: 'https://tickets.lapedrera.iacpospre.com/thankyou',
  URLKO: 'https://tickets.lapedrera.iacpospre.com/thankko',
  URL: 'https://tickets.lapedrera.iacpospre.com',
  siteKey: '6LfXS2IUAAAAADr2WUPQDzAnTEbSQzE1Jxh0Zi0a',
  timer: 20,
  siteKeyV3: '6LcC6uYpAAAAAKWKAGoaja5hIXbOSboGL7UssUnw',
  showCaptcha: true
};
